<div class="redirection-container">
	<h1 class="loading">Just a moment</h1>
	<p>We're redirecting you to the new url... Not working? <a [routerLink]="url">Click here.</a></p>
</div>


